var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 14.5,
    r: 1.5,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.398 4.80078H6.59805C4.60982 4.80078 2.99805 6.41256 2.99805 8.40078V17.4008C2.99805 19.389 4.60982 21.0008 6.59805 21.0008H17.398C19.3863 21.0008 20.998 19.389 20.998 17.4008V8.40078C20.998 6.41256 19.3863 4.80078 17.398 4.80078Z",
    stroke: "#F2F4F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39805 3.00098V6.60098M15.598 3.00098V6.60098M2.99805 10.201H20.998",
    stroke: "#F2F4F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.954bc2fb5e1de558880b644da2f44c7b.svg";
export { ForwardRef as ReactComponent };